import { Helmet } from "react-helmet-async";

export default function ShellPilotAccountDeletion() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <Helmet>
        <title>Account Deletion – ShellPilot</title>
        <meta
          name="description"
          content="How to request account deletion for ShellPilot."
        />
        <link
          rel="canonical"
          href="https://cosmovexapps.com/apps/shellpilot/account-deletion"
        />
      </Helmet>

      <h1 className="text-4xl font-bold mb-6 text-[#A8720E]">
        Account Deletion – ShellPilot
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        If you created a <strong>ShellPilot</strong> account for purchase
        restoration or entitlement management, you may request deletion of your
        account-related data at any time.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        1. How to Request Deletion
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-4 max-w-4xl">
        Send an email to:
      </p>

      <p className="text-lg font-semibold text-[#A8720E] mb-4">
        <a
          href="mailto:trionapps@gmail.com?subject=ShellPilot%20Account%20Deletion"
          className="underline text-[#0F6BBF] hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        In your request, please mention <strong>ShellPilot</strong> and send the
        email from, or clearly reference, the same email address associated with
        your ShellPilot account. This helps us verify ownership before deleting
        account-linked data.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        2. What Will Be Deleted
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-4xl">
        <li>Firebase Authentication account record associated with ShellPilot.</li>
        <li>Server-side entitlement records used for purchase restoration, where applicable.</li>
        <li>Other account-linked backend records we maintain specifically for ShellPilot.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        3. What Will Not Be Removed Automatically
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-4xl">
        <li>Data stored only on your local device, such as saved connections, snippets, or imported keys.</li>
        <li>Remote server content stored on servers you manage.</li>
        <li>Certain records we may need to retain for legal, fraud prevention, accounting, or purchase dispute purposes.</li>
      </ul>

      <p className="text-[#3D4B59] leading-relaxed mt-4 mb-6 max-w-4xl">
        To remove local ShellPilot data from your device, use the app&apos;s local
        data clearing controls or uninstall the app.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        4. Processing Time
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        Once we verify the request, we aim to process account deletion within{" "}
        <strong>7 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">5. Contact</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-4xl">
        If you have questions about ShellPilot account deletion or privacy,
        contact{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: March 11, 2026
      </p>
    </div>
  );
}
